import { render, staticRenderFns } from "./UserDriverData.vue?vue&type=template&id=e5bd76a8&scoped=true&"
import script from "./UserDriverData.vue?vue&type=script&lang=js&"
export * from "./UserDriverData.vue?vue&type=script&lang=js&"
import style0 from "./UserDriverData.vue?vue&type=style&index=0&id=e5bd76a8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5bd76a8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
